var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[(_vm.errorCode)?_c(_vm.error,{tag:"component"}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }